import React from "react";
import { PropsFilter } from "../../../../models/api/props-filter";
import { TransactionDTO } from "../../../../models/transactions";
import AutocompleteDropdown from "../../../../reusable-components/AutocompleteDropdown/AutocompleteDropdown";
import MultipleServiceAutocompleteDropdown from "../../../../reusable-components/MultipleServiceAutocompleteDropdown/MultipleServiceAutocompleteDropdown";
import { LegalEntityBankAccountsApiService } from "../../../../services/legal-entity-bank-accounts/legal-entity-bank-accounts-api.service";
import { LegalEntityCashStatementApiService } from "../../../../services/legal-entity-cash-statements/legal-entity-cash-statements-api.service";
import { BANK_TYPES } from "../../../../utils/constants/constants";

interface Props {
  transaction: TransactionDTO;
  bankAndCashAccounts: string[];
  handleChange: (field: keyof TransactionDTO, value: TransactionDTO[keyof TransactionDTO]) => void;
}

const BankAndCashComponent = ({
  handleChange,
  bankAndCashAccounts,
  transaction: { fromWhichBankAccount, fromWhichCashAccount, toWhichBankAccount, toWhichCashAccount },
  transaction,
}: Props) => {
  const tRP = "pages.system_settings.tables.transaction_types.fields_configs"; // tRP - translation root path

  const changeAccountField = (field: "from" | "to", value: any) => {
    if (field === "from") {
      value?.bankType?.id === BANK_TYPES.bank_accounts.id
        ? handleChange("fromWhichBankAccount", value)
        : handleChange("fromWhichCashAccount", value);
    } else {
      value?.bankType?.id === BANK_TYPES.bank_accounts.id
        ? handleChange("toWhichBankAccount", value)
        : handleChange("toWhichCashAccount", value);
    }
  };

  const isFromWhichBankAccount = bankAndCashAccounts.find((acc) => acc === "FromWhichBankAccount");
  const isFromWhichCashAccount = bankAndCashAccounts.find((acc) => acc === "FromWhichCashAccount");

  const fromBankAndCash = !!isFromWhichBankAccount && !!isFromWhichCashAccount;

  const isWhichBankAccount = bankAndCashAccounts.find((acc) => acc === "ToWhichBankAccount");
  const isToWhichCashAccount = bankAndCashAccounts.find((acc) => acc === "ToWhichCashAccount");

  const toBankAndCash = !!isWhichBankAccount && !!isToWhichCashAccount;

  return (
    <>
      {fromBankAndCash ? (
        <MultipleServiceAutocompleteDropdown
          labelKey={`${tRP}.from_which_account`}
          field="from"
          fieldProp="name"
          multipleServiceApi={[new LegalEntityBankAccountsApiService(), new LegalEntityCashStatementApiService()]}
          handleChange={changeAccountField}
          sxProps={{ maxWidth: "300px" }}
          selectedValue={
            fromWhichBankAccount ?? fromWhichCashAccount ? fromWhichBankAccount ?? fromWhichCashAccount : null
          }
          propsFilter={
            {
              legalEntityIds: transaction?.legalEntity?.id ? [transaction?.legalEntity?.id] : [],
            } as PropsFilter
          }
        />
      ) : (
        <div>
          {isFromWhichBankAccount && (
            <AutocompleteDropdown
              labelKey={`${tRP}.fromWhichBankAccount`}
              field="fromWhichBankAccount"
              serviceApi={new LegalEntityBankAccountsApiService()}
              propsItem={transaction}
              handleChange={handleChange}
              sxProps={{ maxWidth: "300px" }}
              propsFilter={
                {
                  legalEntityIds: transaction?.legalEntity?.id ? [transaction?.legalEntity?.id] : [],
                } as PropsFilter
              }
            />
          )}
          {isFromWhichCashAccount && (
            <AutocompleteDropdown
              labelKey={`${tRP}.fromWhichCashAccount`}
              field="fromWhichCashAccount"
              serviceApi={new LegalEntityCashStatementApiService()}
              handleChange={handleChange}
              propsItem={transaction}
              sxProps={{ maxWidth: "300px" }}
              propsFilter={
                {
                  legalEntityIds: transaction?.legalEntity?.id ? [transaction?.legalEntity?.id] : [],
                } as PropsFilter
              }
            />
          )}
        </div>
      )}
      {toBankAndCash ? (
        <MultipleServiceAutocompleteDropdown
          labelKey={`${tRP}.to_which_account`}
          field="to"
          multipleServiceApi={[new LegalEntityBankAccountsApiService(), new LegalEntityCashStatementApiService()]}
          handleChange={changeAccountField}
          sxProps={{ maxWidth: "300px" }}
          selectedValue={toWhichBankAccount ?? toWhichCashAccount ? toWhichBankAccount ?? toWhichCashAccount : null}
          propsFilter={
            {
              legalEntityIds: transaction?.legalEntity?.id ? [transaction?.legalEntity?.id] : [],
            } as PropsFilter
          }
        />
      ) : (
        <div>
          {isToWhichCashAccount && (
            <AutocompleteDropdown
              labelKey={`${tRP}.toWhichCashAccount`}
              field="toWhichCashAccount"
              serviceApi={new LegalEntityCashStatementApiService()}
              handleChange={handleChange}
              propsItem={transaction}
              sxProps={{ maxWidth: "300px" }}
              propsFilter={
                {
                  legalEntityIds: transaction?.legalEntity?.id ? [transaction?.legalEntity?.id] : [],
                } as PropsFilter
              }
            />
          )}
          {isWhichBankAccount && (
            <AutocompleteDropdown
              labelKey={`${tRP}.toWhichBankAccount`}
              field="toWhichBankAccount"
              fieldProp="name"
              serviceApi={new LegalEntityBankAccountsApiService()}
              handleChange={handleChange}
              propsItem={transaction}
              sxProps={{ maxWidth: "300px" }}
              propsFilter={
                {
                  legalEntityIds: transaction?.legalEntity?.id ? [transaction?.legalEntity?.id] : [],
                } as PropsFilter
              }
            />
          )}
        </div>
      )}
    </>
  );
};

export default BankAndCashComponent;
